export { default, type HeadingProps } from './Heading';
